import * as Yup from 'yup';
import { t } from 'ttag';

export const employeeValidationSchema = Yup.object().shape({
  name: Yup.string().required(t`Required field.`),
  email: Yup.string()
    .required(t`Required field.`)
    .matches(/^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/),
  costCenter: Yup.string().nullable(),
  roles: Yup.array().nullable(),
  disabled: Yup.boolean()
});
